<template>
  <div class="commerce-details-shop-panel">
    <button class="delete is-large is-pulled-right" @click="close" />
    <p class="subtitle">
      Shop Details
      <span class="icon" @click="goto(`/shop/${t.business_id}`)"
        ><i class="fa fa-external-link-alt fa-sm has-text-info"
      /></span>
    </p>

    <p @click="getViewingHistory">Commerce Agent View History</p>
    <div v-if="viewingHistory">
      <div class="list">
        <p
          v-if="!viewingHistory.length"
          class="list-item has-text-danger has-text-weight-medium"
        >
          No Views
        </p>
        <p v-for="a in viewingHistory" :key="a.name" class="list-item">
          {{ a.name }}
          <span class="is-pulled-right tag is-dark">{{
            timeAgo(a.viewed_at)
          }}</span>
        </p>
      </div>
    </div>
    <div v-else>
      <b-skeleton height="36px" />
    </div>

    <p style="margin-top: 16px" @click="getCommerceAgents">Commerce Agents</p>
    <div v-if="commerceAgents">
      <div class="list">
        <p v-if="!commerceAgents.length" class="list-item has-text-danger">
          <i>No Commerce Agents</i>
        </p>
        <p v-for="a in commerceAgents" :key="a.name" class="list-item">
          <a class="has-text-info" @click="callAgent(a.phone_number)">{{
            a.phone_number
          }}</a>
          {{ shortenString(a.name, 16) }}
          <span class="is-pulled-right">
            <i
              v-if="a.has_notifications"
              class="fa fa-bullhorn fa-sm has-text-success"
              style="margin-right: 6px"
            />
            <span
              class="tag is-dark"
              @click="goto(`/user_info/${a.user_id}`)"
              >{{ timeAgo(a.updated_at) }}</span
            >
          </span>
        </p>
      </div>
    </div>
    <div v-else><b-skeleton height="36px" /></div>

    <p style="margin-top: 16px">
      Boss Phone
      <a class="is-pulled-right">{{ "TODO: Boss Phone" }}</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "CommerceDetailsShopPanel",
  props: {
    t: Object, // transaction
  },
  data() {
    return {
      viewingHistory: null,
      commerceAgents: null,
    };
  },
  mounted() {
    this.getViewingHistory();
    this.getCommerceAgents();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    callAgent(phoneNumber) {
      setTimeout(() => this.callPhoneNumber(phoneNumber), 1500);
      this.$copyText(phoneNumber);
      this.infoToast("Copied " + phoneNumber);
    },
    getViewingHistory() {
      this.viewingHistory = null;
      this.$store
        .dispatch("getCommerceOrderViewingHistory", this.t.id)
        .then((res) => {
          if (res.data) this.viewingHistory = res.data;
          else this.viewingHistory = [];
        })
        .catch((err) => this.apiError(err));
    },
    getCommerceAgents() {
      this.commerceAgents = null;
      this.$store
        .dispatch("getCommerceAgentsInfo", this.t.workflow_id)
        .then((res) => {
          if (res.data) this.commerceAgents = res.data;
          else this.commerceAgents = [];
        })
        .catch((err) => this.apiError(err));
    },
  },
};
</script>

<style scoped>
.commerce-details-shop-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 10px;
  background-color: #1f1b24;
  color: white;
  padding-bottom: 20px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 0 4px 4px white;
}
.subtitle {
  margin-bottom: 16px;
  color: #ccc;
}
.list {
  background-color: black;
  margin-top: 6px;
}
.list-item {
  color: white;
  border-bottom: 1px solid #333;
  padding: 4px 6px;
}
</style>